/**
 * Date    : 2021/11/22
 * Author  : WeiLin
 * Declare : index
 */

import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Pagination as PaginationNode  } from '@/components/AntD';

import './index.scss';

export default function Pagination(props) {

  const { className, ...restProps } = props;

  const showTotal = (totalCount) => {
    return `共 ${totalCount} 项`;
  };

  const pageConfig = useMemo(() => {
    let pageConfig = restProps;
    if('style2' in props) {
      pageConfig = Object.assign({}, {
        size: 'small',
        showQuickJumper: true,
        showTotal
      }, pageConfig);
    }
    return pageConfig;
  }, [props]);
  return (
    <PaginationNode className={classNames(`Pagination`, { 'Pagination-style2': props.style2 }, className)} {...pageConfig} hideOnSinglePage={!pageConfig.total} />
  );
}

Pagination.defaultProps = {
  className: '',
  hideOnSinglePage: true
};
